import { ExportType } from '@/modules/ta/reportstudio/reportstudio.constants';

export const getters = {
  /**
   * @param {ExportState} state
   * @returns {boolean}
   */
  isExporting(state) {
    return state.isExporting;
  },
  /**
   * @param {ExportState} state
   * @returns {boolean}
   */
  isScheduledExport(state) {
    return state.config.exportType !== ExportType.TYPE_SCHEDULED_REPORT_PDF;
  },
  isSingleWidgetExport(state) {
    return state.config?.isExportingSingleWidget;
  },
  /**
   * @param {ExportState} state
   * @returns {{}}
   */
  getConfig(state) {
    return state.config;
  },
  /**
   * exports are either used as html in the browser or puppeteer
   * @returns {boolean}
   */
  getIsCapturing({ config }) {
    return !config.isHtml;
  },
  /**
   * if a widget is a "ghost" widget it'll exist in this map
   * @param state
   * @param widgetId
   * @returns {*}
   */
  getGhostWidget(state, widgetId) {
    return state.ghostWidgets[widgetId];
  },
};
